export const shallowCopy = value => {
  if (Array.isArray(value)) {
    return [...value];
  }
  if (value instanceof Map) {
    return new Map(value);
  }
  if (value instanceof Set) {
    return new Set(value);
  }
  if (typeof value === 'object' && value !== null) {
    return Object.assign({}, value);
  }
  return value;
};